"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialMediaPostRoutes = void 0;
exports.socialMediaPostRoutes = [
    {
        name: 'social-media-dictionary.list',
        path: '/dictionaries',
        method: 'GET'
    },
    {
        name: 'social-media-dictionary.get',
        path: '/dictionaries/:id',
        method: 'GET'
    },
    {
        name: 'social-media-dictionary.create',
        path: '/dictionaries',
        method: 'POST'
    },
    {
        name: 'social-media-dictionary.update',
        path: '/dictionaries/:id',
        method: 'PUT'
    },
    {
        name: 'social-media-dictionary.delete',
        path: '/dictionaries/:id',
        method: 'DELETE'
    },
    {
        name: 'social-media-post.list',
        path: ['/post', '/post/q/:q'],
        method: 'GET'
    },
    {
        name: 'social-media-post.create',
        path: ['/post'],
        method: 'POST'
    },
    {
        name: 'social-media-post.get',
        path: '/post/:id',
        method: 'GET'
    },
    {
        name: 'social-media-post.update',
        path: '/post/:id',
        method: 'PUT'
    },
    {
        name: 'social-media-post.duplicate',
        path: '/post/:id/duplicate',
        method: 'POST'
    },
    {
        name: 'social-media-post.delete',
        path: '/post/:id',
        method: 'DELETE'
    },
    {
        name: 'social-media-post.generate-image',
        path: '/post/generate-image',
        method: 'POST'
    },
    {
        name: 'social-media-post.upload-image',
        path: '/post/upload-image',
        method: 'POST'
    },
    {
        name: 'social-media-post.upload-video',
        path: '/post/upload-video',
        method: 'POST'
    },
    {
        name: 'social-media-post.publish',
        path: '/post/:id/publish',
        method: 'POST'
    },
];
